
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
//import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import Odontograma from './Odontograma.vue';
import InformacionClinica from './InformacionClinicaTab.vue'
import Historial from "./Historial.vue";
import RxDocumentos from "./RxDocumentos.vue"
import Pagos from "./Pagos.vue"
import Fichas from "./Ficha.vue"
import Recetas from "./recetas/Index.vue"
import FichaColor from "./fichaColor/Index.vue"
import { Reporte } from "@/addons/Reporte";
import HeadReport from "@/components/HeadReport.vue";
import FichaArtificiales from "./fichaDientesArtificiales/Index.vue";
@Component({
	name: "NuevoPaciente",
	components: {Odontograma, InformacionClinica, Historial, RxDocumentos, Pagos, Fichas, Recetas, FichaColor, HeadReport, FichaArtificiales}
})

export default class NuevoPaciente extends Vue {
	//@Prop() pacienteEdit!: any
	//@Prop() dialog!: boolean
	//@Prop() swEditar!: boolean

	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	tab = null;


	// paciente = {
	// 	nombre: '',
	// 	apellidos: '',
	// 	fecha_nacimiento: '',
	// 	genero: '',
	// 	direccion: '',
	// 	telefono: '',
	// 	email: '',
	// 	encargado: '',
	// 	ci: ''
	// }
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');

	get paciente() {
		return this.consultorioStore.paciente;
	}
	mounted() {
		this.showPaciente();
		this.consultorioService.getTratamientos();
		this.consultorioService.getCaras();
	}
	close() {
		this.$router.push({ name: 'pacientes' });
	}
	guardar() {
		if (!this.$refs.form.validate()) {
			Alert.warning(`Lene todos los campos obligatorios (*)`)
			return;
		}
		if (!this.swEditar) {
			Alert.confirm(`Se realizará el registro del paciente ${this.paciente.nombre} ${this.paciente.apellidos}`, 'Registrar nueva Paciente?').then(async result => {
				if (result.isConfirmed) {
					await this.consultorioService.registrarPaciente(this.paciente).then(response => {

						this.limpiar()
						this.close()
						//this.listar()
					})

				}
			})
		} else {
			Alert.confirm(`Se realizará la modificacion de la venta`, 'Modificar venta?').then(async result => {
				if (result.isConfirmed) {
					await this.consultorioService.editarVenta(this.venta)
					this.limpiar()
				}
			})
		}

	}
	
	showPaciente(){
		this.consultorioService.showPaciente(this.$route.query.id)
	}
	imprimir() {
    const css = ".print table {border-collapse: collapse} .print td {padding:0.5 !important; font-size: xx-small !important;}"
    const p = new Reporte('area_impresion');
    p.orientacion ='vertical';
    p.otroCss = css;
    p.imprimir();
  }

	
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	
}

